<template>
  <div class="single-obituary-mobile-navigation" v-if="isMobile || isTablet">
    <transition name="show-mobile-nav">
      <div
        class="single-obituary-mobile-navigation__items container"
        key="loaded"
        v-if="!loading"
      >
        <share-cta />
        <flower-cta v-if="middle === 'flowers'" @click="trackMiddle" />
        <donation-cta
          v-else-if="middle === 'memorial_gift'"
          @click="trackMiddle"
        />
        <add-media-cta v-else-if="middle === 'photos'" @click="trackMiddle" />
        <life-story-cta
          v-else-if="middle === 'life_story'"
          @click="trackMiddle"
        />
        <create-comment-cta v-if="!noGreetings" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
  import { useIsMobile } from "Main/composables/useIsMobile";
  import {
    computed,
    defineComponent,
    getCurrentInstance,
    onMounted,
    ref,
  } from "vue";
  import { useStore } from "vuex";
  import {
    hasSlideshow,
    lifeStoryOnPage,
    quickContent,
  } from "../../composables/useSlideshow";
  import { barButton, barMiddle } from "../../highlights/bar";
  import {
    currentCards,
    pagePhase,
    parseHighlights,
  } from "../../highlights/cards";
  import { mediaCount } from "../../slideshow/playlist";
  import { trackHighlight } from "../../slideshow/track";
  import AddMediaCta from "./AddMediaCta.vue";
  import CreateCommentCta from "./CreateCommentCta.vue";
  import DonationCta from "./DonationCta.vue";
  import FlowerCta from "./FlowerCta.vue";
  import LifeStoryCta from "./LifeStoryCta.vue";
  import ShareCta from "./ShareCta.vue";

  declare const lavendlaObituary: { noGreetings: boolean };

  export default defineComponent({
    components: {
      AddMediaCta,
      CreateCommentCta,
      DonationCta,
      FlowerCta,
      LifeStoryCta,
      ShareCta,
    },
    name: "MobileNavigation",

    setup() {
      const { isMobile, isTablet } = useIsMobile();
      const store = useStore();
      const mountEl = getCurrentInstance()?.proxy?.$mountEl as
        | HTMLElement
        | undefined;

      // The same phase and cards as the highlights block, so the bar follows the funeral.
      const highlights = parseHighlights(mountEl?.dataset.highlights);
      const now = new Date();
      const content = quickContent();
      const phase = pagePhase(
        highlights.ceremonyDate,
        now,
        highlights.timeZone
      );
      const middle = barButton(
        phase,
        currentCards({
          hasSlideshow: hasSlideshow(),
          highlights,
          lifeStory: lifeStoryOnPage(),
          now,
        }),
        content ? mediaCount(content) : 0
      );
      barMiddle.value = middle;

      const mounted = ref(false);
      onMounted(() => {
        mounted.value = true;
      });

      return {
        isMobile,
        isTablet,
        loading: computed(() => !mounted.value || store.state.orders.isLoading),
        middle,
        noGreetings: lavendlaObituary.noGreetings,
        trackMiddle: () => {
          if (middle) {
            trackHighlight({ action: "bar_click", card: middle, phase });
          }
        },
      };
    },
  });
</script>
